import { useTranslation } from 'react-i18next';

const LOGO_SRC =
  'https://public.readdy.ai/ai/img_res/c06b3c58-8705-4d01-8539-ae825176d894.png';

type BrandLogoProps = {
  /** Tailwind class that controls the logo height, e.g. "h-10" */
  className?: string;
  /** Wrap the logo in a light chip so it stays readable on dark backgrounds */
  onDark?: boolean;
};

export default function BrandLogo({ className = 'h-10', onDark = false }: BrandLogoProps) {
  const { t } = useTranslation();

  const logo = (
    <img src={LOGO_SRC} alt={t('brand.name')} className={`${className} w-auto object-contain`} />
  );

  if (onDark) {
    return (
      <span className="inline-flex items-center justify-center rounded-lg bg-background-50 px-3 py-1.5">
        {logo}
      </span>
    );
  }

  return logo;
}